import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { AuthProviderIdentifier } from "../../../login/AuthProviderIdentifier.js";
import { UserRole } from "../../../login/UserRole.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import {  EvaluatedAction, EvaluatedActionType } from "../../EvaluatedAction.js";

/**
 * this is step one of the decomposed login proposal behaviour as documented in #10999 - https://op.mgmtcp.com/issues/10999
 * @param sdk 
 * @param _logger 
 * @returns 
 */
export function evaluateMaybeInteractiveAutologinProposal(sdk: ClientSdkPublicInterface, _logger: Logger): Promise<EvaluatedAction<any>|null> {
    const session = sdk.getCurrentSession();
    return sdk.isAutologinLocked().then(isLocked => {
        if((session && session.role == UserRole.AUTHENTICATED_USER) || isLocked ) {
            return Promise.resolve(null);
        }
        else {
            const detected = sdk.webviewDetect();
            
            if(!detected.native_app && detected.browser.chrome && !detected.browser.webview) {
                return Promise.resolve({
                    data: {
                        oneTap: true,
                        providerId: [AuthProviderIdentifier.GOOGLE_ONE_TAP]
                    },
                    type: EvaluatedActionType.SUBMIT_LOGIN
                });
            }
            else {
                return Promise.resolve(null);
            }       
        }
    });
    
                
}